<app-page-bar></app-page-bar>

<app-page>
  <div class="template-container" *ngIf="template">
    <header class="form-header">
      <h1>{{ isNew ? 'New Email Template' : 'Edit Email Template' }}</h1>
      <p class="subtitle" *ngIf="!isNew">{{ template.name }}</p>
    </header>

    <form [formGroup]="form" (ngSubmit)="saveTemplate()" novalidate class="modern-form">
      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>Template Name</mat-label>
          <input matInput formControlName="name" placeholder="e.g., Welcome Email" required />
          <mat-error *ngIf="form.get('name').hasError('required')">Name is required</mat-error>
        </mat-form-field>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description" placeholder="Internal notes about this template" />
        </mat-form-field>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>Subject Line</mat-label>
          <input matInput formControlName="subject" placeholder="Email subject" />
        </mat-form-field>
      </div>

      <div class="field-row message-field">
        <mat-form-field appearance="outline">
          <mat-label>Message Body</mat-label>
          <textarea matInput formControlName="message" rows="12" placeholder="Write your email content here..."></textarea>
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="!form.valid">
          {{ isNew ? 'Create Template' : 'Save Changes' }}
        </button>
        <button mat-button type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>

    <section class="variables-reference">
      <h2>Allowed Variables</h2>
      <ul>
        <li>client name</li>
        <li>client businessid</li>
        <li>invoice orignum</li>
        <li>invoice newnum</li>
        <li>invoice amount</li>
        <li>estimated financed amount</li>
        <li>estimated final payment amount</li>
        <li>offer verification pin</li>
        <li>dispute verification pin</li>
        <li>offer verification url</li>
        <li>dispute verification url</li>
      </ul>
    </section>
  </div>
</app-page>
